import axios from "axios";
import * as types from "../mutation-types";
import api from "@/api/api";

export const state = {
  totalEmployees: 0,
  companies: {},
  employeeSeniority: [],
  totalDivision: 0,
  divisions: {},
  employeeByGrade: {},
  employeeFluctuating: {},
  divisionColors: {}
}

export const getters = {
  totalEmployees: state => state.totalEmployees,
  companies: state => state.companies,
  totalDivisions: state => state.totalDivisions,
  divisions: state => state.divisions,
  divisionColors: state => state.divisionColors,
  employeeSeniority: state => state.employeeSeniority,
  employeeByGrade: state => state.employeeByGrade,
  employeeFluctuating: state => state.employeeFluctuating
}

export const mutations = {
  SET_EMPLOYEEES(state, data) {
    state.companies = data;
    let totalEmployeees = 0;
    for (const company in data) {
      totalEmployeees += data[company];
    }
    state.totalEmployees = totalEmployeees;
  },
  SET_DIVISIONS(state, data) {
    
    let totalDivisions = {};
    let divisionColors = {};
    let colorStack = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];
    for (const divisions in data) {
      let totalDivision = 0;
      let divisionColor = colorStack.shift();
      for (const division in data[divisions]) {
        totalDivision += data[divisions][division];
        divisionColors[divisions] = divisionColor;
      }
      totalDivisions[divisions] = totalDivision;
    }
    if (data.OTHER) {
      for (const otherItem in data.OTHER) {
        if (totalDivisions[otherItem]) {
          totalDivisions[otherItem] += data.OTHER[otherItem] ?? 0;
          totalDivisions['OTHER'] -= data.OTHER[otherItem] ?? 0;
        }
      }
    }
    state.divisions = data;
    state.divisionColors = divisionColors;
    state.totalDivisions = totalDivisions;
  },
  SET_EMPLOYEEES_SENIORITY(state, data) {
    state.employeeSeniority = data;
  },
  SET_EMPLOYEE_BY_GRADE(state, data) {
    state.employeeByGrade = data;
  },

  GET_FLUCTUATING_SENIORITY(state, data) {
    state.employeeFluctuating = data;
  },
}

export const actions = {
  async getEmployeees({
    commit
  }) {
    let url = `${api.GET_EMPLOYEEES}`;
    const res = await axios.get(url);
    commit(types.DASHBOARD.SET_EMPLOYEEES, res.data);
  },

  async getCountDivision({
    commit
  }) {
    let url = `${api.GET_COUNT_DIVISION}`;
    const res = await axios.get(url);
    commit(types.DASHBOARD.SET_DIVISIONS, res.data);
  },
  async getEmployeeByGrade({
    commit
  }) {
    let url = `${api.GET_EMPLOYEE_BY_GRADE}`;
    const res = await axios.get(url);
    commit(types.DASHBOARD.SET_EMPLOYEE_BY_GRADE, res.data);
  },
  async getEmployeeesSeniority({
    commit
  }, params) {
    let url = `${api.GET_EMPLOYEE_SENIORITY}`;
    const res = await axios.get(url, params);
    commit(types.DASHBOARD.SET_EMPLOYEEES_SENIORITY, res.data);
  },
  async getEmployeeFluctuating({
    commit
  }, params) {
    let response = await axios.get(api.GET_FLUCTUATING_SENIORITY, {
      params: params
    });
    commit(types.DASHBOARD.GET_FLUCTUATING_SENIORITY, response.data);
  },
  async getPositionAnalytics() {
    return axios.get(api.GET_COUNT_POSITION);
  },
}
